// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-3v5fOJizX0rLSGoeclMuxt","withSections":"withSections-3pqu9QUX1jbH9RoEJG74Ni","header":"header-38HJ2vxsfSoam4y-BY8_a0","content":"content-1rTRrcAbLbgG_S1TjL3Kid"};